import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/material';
import { EmphasisCatalog } from '../../modules/catalogs/catalog.types';
import CatalogCardBase from '../../modules/catalogs/pages/CatalogListPage/components/CatalogCard/CatalogCardBase';
import SortableItem from '../DragAndDrop/SortableItem';
import {
  SortableItemContextProvider,
  useSortableItemContext,
} from '../DragAndDrop/SortableItemContext';
import MediaActionButton from '../MediaActionButton';
import TeceoDragHandle from '../TeceoDraghandle';
import useMediaStyles from '../useMediaStyles';

type SiteCatalogCardProps = {
  item: EmphasisCatalog;
  onRemove?: (item: EmphasisCatalog) => void;
  isDragged: boolean;
};

const SiteCatalogCard = ({ item, onRemove }: SiteCatalogCardProps) => {
  const { classes: mediaClasses } = useMediaStyles({});
  const { elementProps } = useSortableItemContext();

  const handleRemove = () => {
    if (!onRemove) {
      return;
    }

    onRemove(item);
  };

  return (
    <Box className={mediaClasses.root}>
      <CatalogCardBase catalog={item.catalog} />
      <Box className={mediaClasses.mediaControlsTop}>
        <MediaActionButton onClick={handleRemove}>
          <DeleteIcon />
        </MediaActionButton>
        <Box {...elementProps.attributes} {...elementProps.listeners}>
          <TeceoDragHandle />
        </Box>
      </Box>
    </Box>
  );
};

const SortableSiteCatalogCard = (props: SiteCatalogCardProps) => {
  return (
    <SortableItemContextProvider id={props.item.id}>
      <SortableItem isDragged={props.isDragged} key={props.item.id}>
        <SiteCatalogCard {...props} />
      </SortableItem>
    </SortableItemContextProvider>
  );
};

export default SortableSiteCatalogCard;
